export enum Roles {
  superUser = 'Super User',
  client = 'Client',
  clientAdmin = 'Client Admin',
  consultant = 'Consultant'
}
